import {useState} from 'react'
import {useCustomMutation} from '@salesforce/commerce-sdk-react'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {getSiteEnvVarValue} from '../../utils/site-config'

const BRAND_ID = 'GRG'

const useLoyalty = () => {
    const {app: appConfig} = getConfig()
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingTransactions, setIsLoadingTransactions] = useState(true)
    const {site} = useMultiSite()
    const siteId = site?.id

    const {mutateAsync: syncLoyaltyData} = useCustomMutation({
        options: {
            method: 'POST',
            parameters: {
                siteId: site.id
            },
            body: JSON.stringify({
                brand: BRAND_ID
            }),
            customApiPathParameters: {
                apiVersion: 'v1',
                endpointPath: '/sync-data',
                apiName: 'sflm'
            }
        }
    },
    {
        enabled: getSiteEnvVarValue(appConfig, 'SFLM_ENABLED', siteId) == 'true',
        onSuccess: () => {
            setIsLoading(false)
        },
        onError: (error) => {
            setIsLoading(false)
            logger.error('Error syncing loyalty data:', {
                namespace: 'sflm',
                additionalProperties: {error: error.message, stack: error.stack}
            })
        }
    })

    const {mutateAsync: transactionJournal} = useCustomMutation({
        options: {
            method: 'POST',
            parameters: {
                siteId: site.id
            },
            customApiPathParameters: {
                apiVersion: 'v1',
                endpointPath: '/transaction-journal',
                apiName: 'sflm'
            }
        }
    },
    {
        enabled: getSiteEnvVarValue(appConfig, 'SFLM_ENABLED', siteId) == 'true',
        onSuccess: () => {
            setIsLoadingTransactions(false)
        },
        onError: (error) => {
            setIsLoadingTransactions(false)
            logger.error('Error loading transactions:', {
                namespace: 'sflm',
                additionalProperties: {error: error.message, stack: error.stack}
            })
        }
    })


    return {
        isLoading,
        isLoadingTransactions,
        transactionJournal,
        syncLoyaltyData
    }
}

export {useLoyalty}
